import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiBriefcase,
  FiHome,
  FiInbox,
  FiMapPin,
  FiMonitor,
  FiSettings,
  FiShield,
  FiThumbsDown,
  FiThumbsUp,
  FiUser,
} from "react-icons/fi";
import SimpleBar from "simplebar-react";

import { actions, hasPermission } from "./../../services/security";

import classes from "./sidebar.module.scss";

import logo from "./../../assets/images/logo.png";

const Sidebar = () => {
  const [sections, setSections] = useState([
    {
      title: "",
      links: [
        {
          title: "Inicio",
          url: "/",
          icon: <FiHome />,
          visible: true,
        },
        {
          title: "Solicitudes",
          url: "/solicitudes",
          icon: <FiInbox />,
          visible: hasPermission(actions.SolicitudesVer),
        },
        {
          title: "Solicitudes PJ",
          url: "/solicitudesPJ",
          icon: <FiInbox />,
          visible: hasPermission(actions.SolicitudesPJVer),
        },
        {
          title: "Comercios",
          url: "/comercios",
          icon: <FiMapPin />,
          visible: hasPermission(actions.ComerciosVer),
        },
      ],
    },
    {
      title: "Configuración",
      links: [
        {
          title: "Entidades",
          url: "/entidades",
          icon: <FiBriefcase />,
          visible: hasPermission(actions.EntidadesVer),
        },
        {
          title: "Lista Blanca",
          url: "/lista-blanca",
          icon: <FiThumbsUp />,
          visible: hasPermission(actions.ListaBlancaVer),
        },
        {
          title: "Lista Negra",
          url: "/lista-negra",
          icon: <FiThumbsDown />,
          visible: hasPermission(actions.ListaNegraVer),
        },
        {
          title: "Parámetros",
          url: "/parametros",
          icon: <FiSettings />,
          visible: hasPermission(actions.ParametrosVer),
        },
      ],
    },
    {
      title: "Seguridad",
      links: [
        {
          title: "Perfiles",
          url: "/perfiles",
          icon: <FiShield />,
          visible: hasPermission(actions.PerfilesVer),
        },
        {
          title: "Usuarios",
          url: "/usuarios",
          icon: <FiUser />,
          visible: hasPermission(actions.UsuariosVer),
        },
        {
          title: "Auditoría",
          url: "/auditorias",
          icon: <FiMonitor />,
          visible: hasPermission(actions.AuditoriasVer),
        },
      ],
    },
  ]);

  return (
    <div className={classes.sidebar}>
      <div className={classes.brand}>
        <img className={classes.logo} src={logo} alt="logo" />
      </div>
      <SimpleBar style={{ maxHeight: "calc(100vh - 65px)" }}>
        <div className={classes.sections}>
          {sections.map(
            (s, index) =>
              s.links.filter((x) => x.visible).length > 0 && (
                <div key={index} className={classes.section}>
                  <div className={classes.title}>{s.title}</div>
                  {s.links.map(
                    (i, lIndex) =>
                      i.visible && (
                        <NavLink
                          key={lIndex}
                          className={({ isActive }) =>
                            isActive
                              ? `${classes.link} ${classes.active}`
                              : `${classes.link}`
                          }
                          to={i.url}
                        >
                          <div className={classes.icon}>{i.icon}</div>
                          <div className={classes.title}>{i.title}</div>
                        </NavLink>
                      )
                  )}
                </div>
              )
          )}
        </div>
      </SimpleBar>
    </div>
  );
};

export default Sidebar;
